module.exports = __webpack_public_path__ + "static/img/icon_180.598fc2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_180.png
// module id = qyAm
// module chunks = 0